import React from 'react'
import { translate } from 'react-i18next'
import { NewInquiryButton } from '../buttons/NewInquiryButton'

export const NoInquiries = translate()(({ t }) => (
  <div>
    <img className=' img--centered img--rounded' src='/app/images/rateau.png' alt='rateau vide' />
    <p className='paragraph--centered' >
      {t('common:visits:empty_message_first')}.
        </p>
    <p className='paragraph--centered' >
      {t('common:visits:empty_message_second')}.
        </p>
    <div className='new-inquiry__center'>
      <NewInquiryButton />
    </div>
  </div>
))



// WEBPACK FOOTER //
// ./src/components/ui/states/NoInquiries.js